import { mergeStyleSets } from "@fluentui/react";

export const popupStyles = mergeStyleSets({
    root: {
        background: 'rgba(0, 0, 0, 0.5)',
        bottom: '0',
        left: '0',
        position: 'fixed',
        right: '0',
        top: '0',
        zIndex: 999
    },
    content: {
        backgroundColor: "transparent",
        left: '50%',
        padding: '0 2em 2em',
        position: 'absolute',
        maxWidth: "90%!important",
        top: '50%',
        transform: 'translate(-50%, -50%)',
    },
});